import { render, staticRenderFns } from "./BranchOrders.vue?vue&type=template&id=4027ef42&scoped=true&"
import script from "./BranchOrders.vue?vue&type=script&lang=js&"
export * from "./BranchOrders.vue?vue&type=script&lang=js&"
import style0 from "./BranchOrders.vue?vue&type=style&index=0&id=4027ef42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4027ef42",
  null
  
)

export default component.exports